import React, { useEffect, useMemo, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb.js";
import TableContainer from "../../components/Common/TableContainer.js";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select, { components } from "react-select";
import useFetchList from "../../utils/useFetchLIst.js";
import { loaderOverlay } from "../../Style/loaderOverly.js";
import { LoaderCreatePage } from "../Loader/Loader.js";
import {
  baseURL,
  formatDate,
  getRecords,
  saveRecords,
} from "../../services/api.service.js";
import formatDateTime from "../../custom/Utils/formatDateTime.js";
import { Button, Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import TextInput from "../../custom/components/Text-Input/TextInput.js";
import SelectInput from "../../custom/components/Select-Input/SelectInput.js";
import DatePicker from "../../custom/components/Date-Picker/DatePicker.js";
import { ChevronsDown, Download } from "react-feather";
import MultiSelectInput from "../../custom/components/MultiSelect-Input/MultiSelectInput.js";
import { validate } from "../../custom/validations/Validate.js";
import { basicFormData, createPageData } from "./OutgoingInvoicesFile.js";

const OutgoingInvoicesCreate = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState(basicFormData());

  const [loadingData, setLoadingData] = useState(false);
  const [selectedDispatchNo, setSelectedDispatchNo] = useState(null);
  const [dispatchData, setDispatchData] = useState(null);
  const [errors, setErrors] = useState({});
  const [dispatchOptions, setdispatchOptions] = useState([]);
  const [showStockData, setShowStockData] = useState(false);
  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const schema = localStorage.getItem("schema");
  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  } = createPageData();
  const navigate = useNavigate();
  const initialPayload = useMemo(() => payload, []);

  useEffect(() => {
    getDispatchData();
    getBranchData();
  }, []);
  const getDispatchData = async (e) => {
    const schema = localStorage.getItem("schema");

    const payload = {
      modelName: "dispatcheds",
      schema: schema,
      whereCondition: {
        is_active: true,
        is_invoice_generated: false,
      },
      include: [
        {
          model: "material_intakes",
          as: "intake",
        },
      ],
    };
    setLoadingData(true);

    try {
      const res = await getRecords(payload, "/getRecords");
      const dispatchData = res?.data || [];
      const options = dispatchData.map((dispatch) => ({
        value: dispatch?.id,
        label: dispatch?.intake?.material_serial_no || dispatch?.dispatched_no,
      }));
      const finalOptions = [{ value: -1, label: "Select All" }, ...options];

      setdispatchOptions(finalOptions);
    } catch {
      toast.error("Something went wrong");
    } finally {
      setLoadingData(false);
    }
  };
  // Branch drives the form; Zone is auto-derived from the selected branch.
  const getBranchData = async () => {
    setLoadingData(true);
    try {
      const res = await getRecords(
        {
          modelName: "branch_masters",
          schema,
          whereCondition: { is_active: true },
          orderBy: { field: "branch_name", order: "asc" },
          include: [{ model: "zone_masters", as: "zone" }],
        },
        "/getRecords",
      );

      setBranchOptions(
        (res?.data || []).map((b) => ({
          value: b.id,
          label: b.branch_name,
          zone_id: b.zone_id,
          zone_name: b.zone?.zone_name,
        })),
      );
    } catch (err) {
      console.error("Error fetching branches", err);
      setBranchOptions([]);
      toast.error("Something went wrong! Please try again");
    }
    setLoadingData(false);
  };

  const handleBranchSelect = (opt) => {
    setSelectedBranch(opt);

    setFormData((p) => ({
      ...p,
      inputData: {
        ...p.inputData,
        branch_id: opt?.value,
        zone_id: opt ? opt.zone_id : null,
      },
    }));

    // clear branch error
    setFormErrors((prev) => ({
      ...prev,
      branch_id: null,
    }));
  };
  const handleChange = (e) => {
    const { value } = e.target;

    if (!value || value.length === 0) {
      setSelectedDispatchNo([]);
      setErrors({ dispatchNO: "Serial No cannot be blank." });
      setShowStockData(false);
      return;
    }

    const actualOptions = dispatchOptions.filter((opt) => opt.value !== -1);

    const isSelectAll = value.some((item) => item.value === -1);

    if (isSelectAll) {
      setSelectedDispatchNo([{ value: -1, label: "All" }]);
    } else {
      if (value.length === actualOptions.length) {
        setSelectedDispatchNo([{ value: -1, label: "All" }]);
      } else {
        setSelectedDispatchNo(value);
      }
    }

    setErrors({ dispatchNO: null });
    setShowStockData(false);
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    setShowStockData(false);
    if (!Array.isArray(selectedDispatchNo) || selectedDispatchNo.length === 0) {
      setErrors({
        dispatchNO: "Serial No cannot be blank.",
      });
      return;
    }
    setErrors({ dispatchNo: null });

    setLoadingData(true);

    try {
      const dispatchIds = selectedDispatchNo.map((item) => item.value);

      const payload = {
        modelName: "dispatcheds",
        schema: "public",
        include: [
          {
            model: "material_intakes",
            as: "intake",
            include: [
              {
                model: "material_masters",
                as: "material",
              },
            ],
          },
          {
            model: "user_masters",
            as: "dispatched_by_user",
          },
          {
            model: "job_cards",
            as: "job_card",
          },
        ],
        whereCondition: {
          id: dispatchIds,
        },
      };

      const responseData = await saveRecords(payload, "/getRecords");
      setDispatchData(responseData?.data || []);

      setShowStockData(true);
    } catch (error) {
      console.error(error);
      toast.error("An unexpected error occurred. Please try again.");
      setShowStockData(false);
    } finally {
      setLoadingData(false);
    }
  };
  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormErrors((prevErrors) => {
      const fieldError = validate(validationType, { [name]: value });
      return {
        ...prevErrors,
        [name]: fieldError[name] || null,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]:
          type === "checkbox"
            ? checked === true
              ? 1
              : 0
            : name === "alt_mobile_number" && value === ""
              ? null
              : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));

      const validationErrors = validate(validationType, formData.inputData);

      setFormErrors(validationErrors);
      if (JSON.stringify(validationErrors) !== "{}") return;
      // Additional validation for `user_documents`

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };
      const selectedDispatchIds =
        selectedDispatchNo?.map((item) => item.value) || [];

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = {
          ...payload,
          id: id,
          inputData: {
            ...formData.inputData,
            dispatch_ids: selectedDispatchIds, // ✅ added here
          },
        };
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = {
          ...payload,
          inputData: {
            ...formData.inputData,
            dispatch_ids: selectedDispatchIds,
          },
        };
      }

      // console.log(payload);
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "created"} successfully!`,
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`,
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };
  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={"Create Outgoing Invoice"} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <p className="text-muted pb-1">
              Fields marked with <span className="text-danger fw-bold">*</span>{" "}
              are required.
            </p>
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3">
                <div className="col-12 col-md-8">
                  <div className="row align-items-center">
                    <div
                      className="col-12 col-md-6"
                      style={{ minHeight: "85px" }}
                    >
                      <MultiSelectInput
                        label="Select Serial No"
                        options={dispatchOptions}
                        value={selectedDispatchNo}
                        onMultiSelect={(selectedOptions) => {
                          handleChange({
                            target: {
                              name: "dispatchNO",
                              value: selectedOptions || [],
                            },
                          });
                        }}
                        placeholder="Select Serial No"
                        labelClassName="form-label"
                        isClearable={true}
                        asterisk={true}
                        customError={errors.dispatchNO}
                      />
                    </div>
                    <div className="col-6">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{
                          height: "38px",
                          width: "80px",
                          fontSize: "13px",
                          marginTop: "10px",
                          marginRight: "10px",
                        }}
                      >
                        GO
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          {loadingData && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </div>
        {showStockData && (
          <div className="">
            <div className="card mt-4 p-3">
              <h5 className="mb-3 fw-semibold w-100 border-bottom pb-2">
                Selected Dispatch No. Details
              </h5>
              {dispatchData?.length > 0 && (
                <div className="mb-4">
                  {dispatchData.map((item, index) => (
                    <div
                      key={index}
                      className="mb-4 p-3 border rounded shadow-sm"
                      style={{ background: "#f8f9fa", fontSize: "13px" }}
                    >
                      <h6 className="fw-semibold border-bottom pb-2 mb-3 text-primary">
                        {item.dispatched_no}
                      </h6>

                      <Row className="gy-2">
                        {/* ROW 1 */}
                        <Col md="3">
                          <strong>GMDS Code:</strong>{" "}
                          {item?.intake?.material?.gmds_code ||
                            item?.intake?.material?.name ||
                            "-"}
                        </Col>

                        <Col md="3">
                          <strong>Item Description:</strong>{" "}
                          {item?.intake?.material?.descriptions || "-"}
                        </Col>

                        <Col md="3">
                          <strong>Serial No:</strong>{" "}
                          {item?.intake?.material_serial_no || "-"}
                        </Col>

                        <Col md="3">
                          <strong>Intake No.:</strong>{" "}
                          {item?.intake?.intake_no || "-"}
                        </Col>

                        {/* ROW 2 */}
                        <Col md="3">
                          <strong>Job Card No:</strong>{" "}
                          {item?.job_card?.job_card_no || "-"}
                        </Col>

                        <Col md="3">
                          <strong>Status:</strong>{" "}
                          {item?.job_card?.status || "-"}
                        </Col>

                        <Col md="3">
                          <strong>Dispatched Date:</strong>{" "}
                          {item?.dispatch_date
                            ? formatDate(item?.dispatch_date)
                            : "-"}
                        </Col>

                        <Col md="3">
                          <strong>Diapatched By:</strong>{" "}
                          {item?.dispatched_by_user?.full_name || "-"}
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
              )}
              <Row className="">
                <Col md="6" className="mt-3">
                  <SelectInput
                    label="Branch_Dispatched"
                    options={branchOptions}
                    value={selectedBranch}
                    onSelect={handleBranchSelect}
                    placeholder="Select Branch"
                    asterisk={true}
                    customError={formErrors?.branch_id}
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Zone_Dispatched"
                    name="zone"
                    value={selectedBranch?.zone_name || ""}
                    onChange={() => {}}
                    placeholder="-"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    readOnly={true}
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <TextInput
                    label="Outgoing Invoice No"
                    name="invoice_number"
                    value={formData?.inputData?.invoice_number}
                    onChange={onInputChange}
                    placeholder="Enter Outgoing Invoice No"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    asterisk={true}
                    customError={
                      formErrors.invoice_number
                        ? "Outgoing invoice No cannot be blank."
                        : ""
                    }
                  />
                </Col>
                <Col md="6" className="mt-3">
                  <DatePicker
                    label="Outgoing Invoice Date"
                    name="invoice_date"
                    value={formData?.inputData?.invoice_date}
                    onChange={onInputChange}
                    placeholder="Select Outgoing Invoice Date"
                    inputClassName="form-control"
                    labelClassName="form-label"
                    asterisk={true}
                    customError={formErrors?.invoice_date}
                  />
                </Col>
              </Row>
              <div className="mt-3 d-flex gap-3 flex-wrap">
                <button
                  type="button"
                  onClick={handleSubmit}
                  className="btn btn-primary"
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => {
                    navigate(navigatePage?.back);
                  }}
                  className="btn btn-secondary"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OutgoingInvoicesCreate;
